import { createSlice } from "@reduxjs/toolkit";

export interface ShoppingCartSliceState {
  // replacedNotInStockWithConsolidation: boolean,
  showSideShoppingCart: boolean;
  showToast: boolean;
  toastMessage: string;
  toastSubMessage: string;
  toastType: "error" | "success";
  /** Whether to show the "Proceed to Checkout" CTA (add-to-cart: yes; remove-from-cart: no). */
  showCheckoutLink: boolean;
}
const initialState: ShoppingCartSliceState = {
  // replacedNotInStockWithConsolidation: false,
  showSideShoppingCart: false,
  showToast: false,
  toastMessage: "",
  toastSubMessage: "",
  toastType: "success",
  showCheckoutLink: true,
};

export const shoppingCartSlice = createSlice({
  name: "shoppingCartSlice",
  initialState,
  reducers: {
    showSideShoppingCart: (state) => {
      state.showSideShoppingCart = true;
    },
    hideSideShoppingCart: (state) => {
      state.showSideShoppingCart = false;
    },
    showCartToast: (state, action) => {
      state.showToast = true;
      if (typeof action.payload == "string") {
        state.toastMessage = action.payload;
        state.toastSubMessage = "";
        state.toastType = "success";
        state.showCheckoutLink = true;
      } else {
        state.toastMessage = action.payload.message;
        state.toastSubMessage = action.payload.subMessage ?? "";
        state.toastType = action.payload.type ?? "success";
        state.showCheckoutLink = action.payload.showCheckoutLink ?? true;
      }

      return state;
    },
    hideCartToast: (state) => {
      state.showToast = false;
      state.toastMessage = "";
      state.toastSubMessage = "";
      state.toastType = "success";
      state.showCheckoutLink = true;

      return state;
    },
  },
});

export const { showSideShoppingCart, hideSideShoppingCart, showCartToast, hideCartToast } = shoppingCartSlice.actions;
export default shoppingCartSlice;
